export function asyncRoute(path:string, name:string, loader, useAsDefault?:boolean) {
  return {
    path: path,
    name: name,
    loader: () => new Promise(loader),
    useAsDefault: useAsDefault,
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/shared/utils/route.util.ts
 **/